<template>
  <div class="card">
    <div class="card-image">
      <figure class="thumbnail" ref="image">
        <canvas ref="canvas"></canvas>
      </figure>
    </div>
    <div class="card-content">
      <div class="columns">
        <div class="column">{{ image.fileObject.name }}</div>
      </div>
      <div class="image-tags">
        <a
          class="tag is-link"
          v-for="tag in image.tags"
          :key="tag"
          v-on:click.stop="$emit('tag-click', tag)"
        >{{ tag }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import preScaleImg from '../imgScale';
export default {
  props: ["image"],
  data() {
    return {
      objectUrl: undefined,
      orientation: -2
    };
  },
  mounted() {
    const config = {
      treshold: 0.9
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(async entry => {
        if (entry.intersectionRatio > 0) {
          if (!this.image.objectUrl) {
            this.drawImage();
          }
        }
      });
    }, config);
    observer.observe(this.$refs.image);
  },
  updated() {
    if(this.image.objectUrl != this.objectUrl) {
      this.drawImage();
    }
  },
  destroyed() {
    //TODO: revoke in store when deleting uploadimage from store
    /*ctUrl) {
      //console.log("revoking ", this.image.fileObject.name);
      window.URL.revokeObjectURL(this.image.objectUrl);
    }*/
  },
  methods: {
    async drawImage() {
      let canvas = this.$refs.canvas;
      if(!canvas) {
        return;
      }
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      if(this.image.scaledImage && this.image.objectUrl != this.objectUrl) {
        let ctx = canvas.getContext("2d");
        let img = this.image.scaledImage;
        let scale = canvas.offsetWidth / img.width;
        if(scale * img.height > canvas.offsetHeight) {
          scale = canvas.offsetHeight / img.height;
        }
        let x = (canvas.offsetWidth - img.width*scale)/2;
        let y = (canvas.offsetHeight - img.height*scale)/2;
        ctx.drawImage(img, x, y, img.width, img.height);
        return;
      }
      if (!this.image.objectUrl) {
        //this.image.orientation = await detectOrientation(this.image.fileObject);
        this.image.objectUrl = window.URL.createObjectURL(this.image.fileObject);
        this.objectUrl = this.image.objectUrl;
        //draw on canvas
        let img = new Image();
        img.onload = () => {
          let ctx = canvas.getContext("2d");
          let scale = 1;
          scale = canvas.offsetWidth / img.width;
          if(scale * img.height > canvas.offsetHeight) {
            scale = canvas.offsetHeight / img.height;
          }
          let x = (canvas.offsetWidth - img.width*scale)/2;
          let y = (canvas.offsetHeight - img.height*scale)/2;
          let tmpCanvas = preScaleImg(img, scale);
          if(tmpCanvas.scaled) {
            ctx.drawImage(tmpCanvas.canvas, 0, 0, tmpCanvas.w, tmpCanvas.h, x, y, img.width * scale, img.height * scale);
          } else {
            ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
          }
          let scaledImage = new Image();
          scaledImage.onload = () => {
            this.image.scaledImage = scaledImage;
          }
          scaledImage.src = canvas.toDataURL();
          window.URL.revokeObjectURL(this.image.objectUrl);
        }
        img.src = this.image.objectUrl;
      }
    }
  }
};
</script>
